// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    // apiKey: process.env.REACT_APP_API_KEY,
    // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_APP_ID,
    // measurementId: process.env.REACT_APP_MEASUREMENT_ID


        apiKey: "AIzaSyBVhSvy5tuxgtETAmcndSdZ8wmMgQ2rs-A",
    authDomain: "bigcircleauction.firebaseapp.com",
    projectId: "bigcircleauction",
    storageBucket: "bigcircleauction.firebasestorage.app",
    messagingSenderId: "340771622161",
    appId: "1:340771622161:web:dededc79ca30531df390b0",
    measurementId: "G-M4EC59PXSX"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
export default app;